
export type GuestsCompare = 'maxCapacity' | 'lte';

interface GuestsCompareToggleProps {
  value: GuestsCompare;
  onChange: (mode: GuestsCompare) => void;
  className?: string;
}

const GuestsCompareToggle = ({
  value,
  onChange,
  className = '',
}: GuestsCompareToggleProps) => {
  return (
    <div className={`mt-3 flex items-center gap-2 ${className}`}>
      <span className="text-xs text-gray-600">Criterio:</span>

      <div className="inline-flex rounded-lg border border-gray-200 overflow-hidden">
        <button
          type="button"
          onClick={() => onChange('maxCapacity')}
          className={`px-3 py-1 text-xs transition-colors ${
            value === 'maxCapacity'
              ? 'bg-gray-900 text-white'
              : 'bg-white text-gray-700 hover:bg-gray-50'
          }`}
          aria-pressed={value === 'maxCapacity'}
        >
          Capacidad mínima (≥)
        </button>

        <button
          type="button"
          onClick={() => onChange('lte')}
          className={`px-3 py-1 text-xs border-l border-gray-200 transition-colors ${
            value === 'lte'
              ? 'bg-gray-900 text-white'
              : 'bg-white text-gray-700 hover:bg-gray-50'
          }`}
          aria-pressed={value === 'lte'}
        >
          Hasta (≤)
        </button>
      </div>
    </div>
  );
};

export default GuestsCompareToggle;
